import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {animate, style, transition, trigger} from "@angular/animations";
import {PhoneNumberUtil} from 'google-libphonenumber';

export const INVALID_PHONE_NUMBER = 'invalidPhoneNumber'

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
    try {
      const phoneNumber = phoneUtil.parse(control.value, 'JP');
      return !phoneUtil.isValidNumberForRegion(phoneNumber, 'JP') ? {'invalidPhoneNumber': true} : null;
    } catch (e) {
      return {'invalidPhoneNumber': true}
    }
  };
}

@Component({
    selector: 'app-validate-error',
    templateUrl: './validate-error.component.html',
    styleUrls: ['./validate-error.component.scss'],
    animations: [
        trigger('showHideTrigger', [
            transition(':enter', [
                style({
                    'height': 0,
                    'opacity': 0,
                }),
                animate(100, style({
                    'height': '1.3rem',
                    'opacity': 1.0,
                })),
            ]),
            transition(':leave', [
                animate(100, style({
                    'height': 0,
                    'opacity': 0,
                })),
            ])
        ])
    ],
    standalone: false
})
export class ValidateErrorComponent implements OnInit, OnChanges {

  protected readonly INVALID_PHONE_NUMBER = INVALID_PHONE_NUMBER;
  @Input() formCtl: UntypedFormControl | null = null;

  @Input() maxLength?: number;
  @Input() minLength?: number;
  @Input() max?: number;
  @Input() min?: number;

  maxLengthErrorTxt?: string;
  minLengthErrorTxt?: string;
  maxErrorTxt?: string;
  minErrorTxt?: string;

  constructor() {
  }

  ngOnInit(): void {
    this.setErrorTxt();
  }

  ngOnChanges() {
    this.setErrorTxt();
  }

  setErrorTxt(): void {
    this.maxLengthErrorTxt = this.maxLength !== undefined ? `${this.maxLength}文字以内で入力してください` : '最大文字数制限を超えています';
    this.minLengthErrorTxt = this.minLength !== undefined ? `${this.minLength}文字以上で入力してください` : '最小文字数を下回っています';
    this.maxErrorTxt = this.max !== undefined ? `数値は${this.max}以内で入力してください` : '入力最大値を超えています';
    this.minErrorTxt = this.min !== undefined ? `数値は${this.min}以上で入力してください` : '入力最小値を下回っています';
  }
}
